// extracted by mini-css-extract-plugin
export default {"wrapper":"tBcgYQJKdQkqen90tFHd","titleContainer":"qZl7LRoU2GP7ftT8QlQA"};